"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlagsServiceFactory = void 0;
const feature_flags_dev_service_1 = require("./feature-flags-dev-service");
const feature_flags_service_1 = require("./feature-flags-service");
class FeatureFlagsServiceFactory {
    static initialize(featureFlagsOptions) {
        if (window.featureFlagsService) {
            return;
        }
        window.featureFlagsService = FeatureFlagsServiceFactory.create(featureFlagsOptions);
    }
    static create(featureFlagsOptions) {
        if (featureFlagsOptions.isDev) {
            return new feature_flags_dev_service_1.FeatureFlagsDevService();
        }
        return new feature_flags_service_1.FeatureFlagsService(featureFlagsOptions);
    }
}
exports.FeatureFlagsServiceFactory = FeatureFlagsServiceFactory;
